import { isEmpty, isString, map, size, trim } from 'lodash-es';

function processHashtag(text, hashtag) {
  const textMap = [];
  let textToProcess = text;
  const hashTagStartIndex = text.indexOf(hashtag);
  if (hashTagStartIndex > 0) {
    const textBeforeHashtag = text.substring(0, hashTagStartIndex);
    textMap.push({
      element: textBeforeHashtag,
      type: 'text',
      displayText: textBeforeHashtag,
    });
    textToProcess = textToProcess.substring(hashTagStartIndex);
  }

  const id = Number(hashtag.match(/\(([^)]+)\)/)[1]);
  const name = hashtag.match(/\[(.*?)\]/)[1];

  textMap.push({
    element: textToProcess.substring(0, hashtag.length),
    type: name.startsWith('#') ? 'hashtag' : 'user',
    id: id,
    displayText: name,
  });
  textToProcess = textToProcess.substring(hashtag.length);
  return {
    elements: textMap,
    remaining: textToProcess,
  };
}

export function hashtagsToDisplay(text) {
  let displayText = text;
  const textMap = [];
  if (!isEmpty(text) && isString(text)) {
    const mentions = text.match(/(@\[.*?\]\(.*?\))/gi) || [];
    if (size(mentions) > 0) {
      mentions.forEach((hashtag) => {
        const { elements, remaining } = processHashtag(displayText, hashtag);
        textMap.push(...elements);
        displayText = remaining;
      });
    }

    if (!isEmpty(trim(displayText))) {
      textMap.push({
        element: displayText,
        type: 'text',
        displayText: displayText,
      });
    }
  }
  return textMap.map((item, index) => ({ ...item, key: index }));
}
